export default __webpack_public_path__ + "static/media/my_avatar.c6d99331.jpg";